'use strict';

/* global $ */

import { Ajax } from 'utils/ajax';
import { Cookies } from 'utils/cookies';

function Like(options) {

	let opt = $.extend(true, {
	}, options);
	opt = $.extend({
		like: opt.selector+'__like',
		dislike: opt.selector+'__dislike',
	}, opt);


	function initBlock(el) {
		let $el = $(el);

		console.log('[ Like/Init ]');

		let item = $el.data('item');
		let sitem = Cookies.get(item);
		console.log('Item: ', sitem);
		if (!sitem) {
			$el.find(opt.like).removeClass('active');
			$el.find(opt.dislike).removeClass('active');
		} else if (sitem > 0) {
			$el.find(opt.dislike).removeClass('active');
			$el.find(opt.like).attr('data-original-title', 'Уже не нравится');
		} else if (sitem < 0) {
			$el.find(opt.like).removeClass('active');
			$el.find(opt.dislike).attr('data-original-title', 'Уже нравится');
		}

		$(opt.like).on('click', function(e) {
			e.preventDefault();
			let value;
			let item = $(this).parent().data('item');
			let sitem = Cookies.get(item);
			console.error(Cookies.get(item));

			if ($(this).hasClass('active')) {
				Cookies.delete(item);
				$(this).removeClass('active');
				$(this).attr('data-original-title', 'Нравится');
				value = -1;
			} else {
				Cookies.set(item, 1, { max_age: 31536000, secure: 1 });
				$(opt.dislike).removeClass('active');
				$(opt.dislike).attr('data-original-title', 'Не нравится');
				$(this).addClass('active');
				$(this).attr('data-original-title', 'Уже не нравится');
				value = 1;
			}
			let params = $.extend({
				like: value,
			}, $(this).parent().data());
			if (sitem < 0) {
				params.dislike = -1;
			}
			setLike(params);
		});

		$(opt.dislike).on('click', function(e) {
			e.preventDefault();
			let value;
			let item = $(this).parent().data('item');
			let sitem = Cookies.get(item);
			console.error(Cookies.get(item));

			if ($(this).hasClass('active')) {
				Cookies.delete(item);
				$(this).removeClass('active');
				$(this).attr('data-original-title', 'Не нравится');
				value = -1;
			} else {
				Cookies.set(item, -1, { max_age: 31536000, secure: 1 });
				$(opt.like).removeClass('active');
				$(opt.like).attr('data-original-title', 'Нравится');
				$(this).addClass('active');
				$(this).attr('data-original-title', 'Уже нравится');
				value = 1;
			}
			let params = $.extend({
				dislike: value,
			}, $(this).parent().data());
			if (sitem > 0) {
				params.like = -1;
			}
			setLike(params);
		});
	}

	function setLike(params) {

		console.log('[ Like/Init ]');

		Ajax.get('set_like', params).then((data) => {
			if (data.ok) {
				$(opt.like).find('span').html(data.like);
				$(opt.dislike).find('span').html(data.dislike);
			} else {
				console.error('Can\'t change like');
			}
		}).catch(function(error) {
			throw new Error(error);
		});
	}

	$(opt.selector).each(function() {
		initBlock(this);
	});
}

export {
	Like
};
